"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workForm = void 0;
const enums_1 = require("@bemlo/enums");
exports.workForm = {
    [enums_1.WorkForm.ENTREPRENEUR]: 'Jeg vil leies ut via mitt eget foretak',
    [enums_1.WorkForm.HOURLY_WORKER]: 'Vanlig, direkte ansettelse',
    [enums_1.WorkForm.OPEN_TO_BOTH]: 'Eget foretak eller direkte ansettelse',
};
